import {
  FilterGroupItem,
  isFilterGroup,
} from 'services/providers/bapi/entities/filters/types'

const getFilterGroupBySlug = (filterGroups: FilterGroupItem[], slug: string) =>
  filterGroups.find(filterGroup => {
    const key = isFilterGroup(filterGroup)
      ? filterGroup.filterGroupSlug
      : filterGroup.slug
    return key === slug
  })

export const reorderSaleAndSustainableFilterGroups = (
  filterGroups: FilterGroupItem[],
) => {
  const saleFilterGroup = getFilterGroupBySlug(filterGroups, 'sale')
  const sustainableFilterGroup = getFilterGroupBySlug(
    filterGroups,
    'isSustainable',
  )
  const pricesFilterGroup = getFilterGroupBySlug(filterGroups, 'prices')
  const materialFilterGroup = getFilterGroupBySlug(
    filterGroups,
    'materialStyle',
  )

  const hideIndependentSaleAndSustainableFilter = (
    filterGroup: FilterGroupItem,
  ) => {
    if (filterGroup === saleFilterGroup) return false
    if (materialFilterGroup && filterGroup === sustainableFilterGroup)
      return false

    return true
  }

  const reorderedFilterGroups = filterGroups.filter(
    hideIndependentSaleAndSustainableFilter,
  )

  if (materialFilterGroup && sustainableFilterGroup) {
    reorderedFilterGroups.splice(
      reorderedFilterGroups.indexOf(materialFilterGroup as FilterGroupItem) + 1,
      0,
      sustainableFilterGroup as FilterGroupItem,
    )
  }

  if (pricesFilterGroup && saleFilterGroup) {
    reorderedFilterGroups.splice(
      reorderedFilterGroups.indexOf(pricesFilterGroup as FilterGroupItem) + 1,
      0,
      saleFilterGroup as FilterGroupItem,
    )
  }

  return reorderedFilterGroups
}
